import Component from '../../components/Component';
import Loading from '../../components/Loading';
import { withTranslation } from 'react-i18next';

import query from './query';
import keys from './keys';
import Timeline from '../../components/Timeline';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }

    render() {
        const { t } = this.props;

        if (this.state.loading) {
            return <Loading />;
        }

        const extraBox = (
            <>
                <div className="chart-subtitle">{t('discover.stats.new_vs_old.subtitle')}</div>
                <div className="chart-subtitle">{t('discover.stats.new_vs_old.subtitle_2')}</div>
            </>
        );
        return (
            <div
                className="Timeline"
                style={{ height: '100%', minHeight: '150px', position: 'relative' }}
            >
                {this.state.data[0] ? (
                    <div style={{ height: '400px', position: 'relative' }}>
                        <Timeline
                            chartSize="lg"
                            metricType="primary"
                            extraBox={extraBox}
                            header={t('discover.stats.new_vs_old.header')}
                            data={this.state.data}
                            error={this.state.error}
                            forceRun={this.forceRun}
                            keys={keys(t)}
                            dontShowMetrics
                        />
                    </div>
                ) : (
                    <div>{t('global.no_data')}</div>
                )}
            </div>
        );
    }
}

export default withTranslation()(Summary);
